import { when, reaction } from 'mobx';
import { types, getParent, getSnapshot, applySnapshot, destroy } from 'mobx-state-tree';
import cuid from 'cuid';
import dayjs from 'dayjs'

import DateTime from './date';

export const DeviceToken = types
  .model("DeviceToken", {
    id: types.optional(types.identifier, () => cuid()),
    userid: types.string,
    type: types.optional(types.maybeNull(types.string), null),
    token: types.optional(types.maybeNull(types.string), null),
    uuid: types.optional(types.maybeNull(types.string), null),
    name: types.optional(types.maybeNull(types.string), null),
    createdat: types.optional(DateTime, null),
    updatedat: types.optional(DateTime, null),
    deletedat: types.optional(DateTime, null),
  })
  .actions(self => ({
    setProp(prop, value) {
      self[prop] = value;
    },
    update(props) {
      const snap = getSnapshot(self);
      const record = Object.assign(
        {},
        snap,
        props
      );
      applySnapshot(self, record);
    },
    setUserId(userId) {
      self.userId = userId;
    },
    setType(type) {
      self.type = type;
    },
    setUuid(uuid) {
      self.uuid = uuid;
    },
    setName(name) {
      self.name = name;
    },
    setToken(token) {
      self.token = token;
    },
    delete() {
      self.deletedat = dayjs().valueOf();
    },
    remove() {
      getParent(self, 2).remove(self);
    }
  })
);

export const DeviceTokens = types
  .model("DeviceTokens", {
    records: types.array(DeviceToken),
  })
  .actions(self => ({
    add(deviceToken) {
      let token = self.records.find(t => t.token === deviceToken.token);
      if (!token) {
        self.records.push(deviceToken);
        token = self.records[self.records.length - 1];
      }
      return token;
    },
    update(record) {
      let r = self.records.find(r => r.id === record.id);
      if (r) {
        r.remove();
      }
      self.records.push(record);
      return record;
    },
    remove(deviceToken) {
      destroy(deviceToken);
    },
    clear() {
      self.tokens.clear();
    },
  })
);